import { useEffect, useState } from 'react';

import CatalogueApi from '@@src/apis/CatalogueApi';
import { useAppSelector } from '@@src/hooks/store';
import { transformRecommendedItems } from '@@src/transformers/CatalogApiCollectionTransformer';
import { allFavourites } from '@@stores/FavouritesStore';
import OnDemand2 from '@@types/OnDemand2';

const useFavouritesCollection = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [favourites, setFavourites] = useState<OnDemand2.CollectionItem[]>([]);

  const storeFavourites = useAppSelector(allFavourites);

  useEffect(() => {
    const fn = async () => {
      setLoading(true);

      try {
        const response = await CatalogueApi.getFavouritesAll();
        setFavourites(transformRecommendedItems(response as any, '16:9')); // as any is necessary because we need another transformer to handle the news types allowed to be favourited! Eg a collection
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fn();
  }, []);

  const storeFavouriteIds = storeFavourites.map((storeFavourite) => {
    return (storeFavourite.entityId);
  });

  return {
    loading,
    // handle removing favourite
    favourites: favourites.filter((favourite) => {
      return storeFavouriteIds.includes(favourite.id);
    }),
  };
};

export default useFavouritesCollection;
